import React, { useEffect } from 'react';
import AppAvatar from 'components/App/Avatar';
import { FILE_ALLOW_EXTENSIONS, validateImageFile } from 'utils';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import cn from 'utils/classnames';

import s from './index.module.scss';

function AppFormProfilePicture({
  className,
  file,
  setFile,
  defaultValue,
  validateErrorMessage,
}) {
  const ref = React.useRef(null);

  const onFileChange = (e) => {
    const { files } = e.target;
    const [error, selectedFile] = validateImageFile(files[0]);

    if (error) {
      toast.error(error);
      return;
    }

    setFile(selectedFile);
    e.target.value = '';
  };

  const onDropChange = (e) => {
    e.preventDefault();
    const { files } = e.dataTransfer;
    const [error, selectedFile] = validateImageFile(files[0]);

    if (error) {
      toast.error(error);
      return;
    }

    setFile(selectedFile);
  };

  useEffect(() => {
    window.addEventListener('paste', (e) => {
      if (!e.clipboardData) return;

      const [error, selectedFile] = validateImageFile(e.clipboardData.files[0]);

      if (error) {
        toast.error(error);
        return;
      }

      setFile(selectedFile);
    });

    return () => {
      window.removeEventListener('paste', () => { });
    };
  }, []);

  return (
    <div>
      <div
        className={cn('d-flex justify-content-start', className)}
        onDragOver={(e) => e.preventDefault()}
        onDrop={onDropChange}
      >
        <div className={s.Main}>
          <button
            type="button"
            onClick={() => ref.current.click()}
            className={s.Overlay}
            aria-label="Upload Profile Picture"
          >
            <i className="bx bx-image" />
          </button>

          <AppAvatar
            src={file ? URL.createObjectURL(file) : defaultValue}
            name="preview-image"
            isRound={false}
            size={100}
            fontStyle={{ border: '1px solid #ccc' }}
          />

          <input
            ref={ref}
            className={s.Input}
            type="file"
            name="preview-image"
            onChange={onFileChange}
            accept={FILE_ALLOW_EXTENSIONS}
          />
        </div>
      </div>

      {validateErrorMessage && (
        <div className="text-danger">{validateErrorMessage}</div>
      )}
    </div>
  );
}

export default AppFormProfilePicture;

AppFormProfilePicture.propTypes = {
  file: PropTypes.instanceOf(File).isRequired,
  setFile: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  className: PropTypes.string,
  validateErrorMessage: PropTypes.string,
};

AppFormProfilePicture.defaultProps = {
  defaultValue: '',
  className: '',
  validateErrorMessage: '',
};
